export default "__VITE_ASSET__5ceebf14__"